// Khối RIÊNG của trang #/kich-ban/:id (05/10/2026): "Tần suất chạy" (lịch gắn kịch bản — lich-khung.ts) + "Chuỗi kịch bản" (kịch bản này nằm
// trong chuỗi nào, nút "Thêm vào chuỗi", tạo chuỗi mới bắt đầu bằng kịch bản này). Không đụng phần sơ đồ / ô tham số của kich-ban.ts — trang
// chính chỉ gắn khối này vào một hộp trống.
import { api, errMsg } from "../api";
import { busy, clear, h, toast } from "../dom";
import type { Bot } from "../types";
import { taoKhungLich } from "./lich-khung";

export interface KbChoTanSuat { id: string; ten: string; trangThai: string; coSoDo: boolean; botGoiY?: string[] }
interface ChuoiCo { id: string; ten: string; soBuoc: number; viTri?: number[] }

export function taoKhungTanSuat(box: HTMLElement, layKb: () => KbChoTanSuat, layBots: () => Bot[]): { ve: () => void; huy: () => void; hienLich: (hien: boolean) => void } {
  const chuoiBox = h("div");
  const lichBox = h("div");
  // Hai khối ĐỘC LẬP (12/10/2026): "Tần suất chạy" ẩn được riêng (kịch bản SƠ ĐỒ: hẹn giờ chỉ còn nút đỏ trên canvas) mà thẻ "Chuỗi kịch bản" vẫn hiện.
  const khungLich = h("div", { class: "kb-tan-suat", "data-testid": "kb-tan-suat" }, lichBox);
  box.append(khungLich, h("div", { class: "kb-tan-suat", "data-testid": "kb-chuoi-khung" }, chuoiBox));
  const kbId = layKb().id;
  const lich = taoKhungLich(lichBox, {
    duongDan: () => `/api/kich-ban/${encodeURIComponent(kbId)}/lich`,
    layBots,
    botMacDinh: () => (layKb().botGoiY ?? []).filter((id) => layBots().some((b) => b.id === id && b.online)).slice(0, 1),
    tieuDe: "Tần suất chạy",
    goiY: "Đặt giờ để máy tự chạy kịch bản này mỗi ngày đã chọn — chạy liên tục nhiều ngày, mỗi khung giờ một lần/ngày (lệch ngẫu nhiên cho giống người). Lịch luôn chạy THẬT như khi bấm ▶ Chạy (bot tắt / đang tạm dừng thì bỏ qua kèm lý do); giới hạn mỗi ngày của kịch bản vẫn áp dụng.",
    testId: "kb-lich",
  });

  let co: ChuoiCo[] = [];
  let khac: ChuoiCo[] = [];
  let loi: string | null = null;
  let song = true;
  let daTai = false;
  const tai = async (): Promise<void> => {
    try { const r = await api<{ chuoi: ChuoiCo[]; khac: ChuoiCo[] }>("GET", `/api/kich-ban/${encodeURIComponent(kbId)}/chuoi`); co = r.chuoi; khac = r.khac; loi = null; }
    catch (e) { loi = errMsg(e); }
    daTai = true;
    if (song) veChuoi();
  };
  // Thẻ dựng MỘT lần; tải lại chỉ thay danh sách + ô chọn (thẻ không bị thay khi người dùng đang thao tác).
  const ds = h("ul", { class: "ls-ds", "data-testid": "kb-chuoi-ds" });
  const chon = h("select", { "data-testid": "kb-chuoi-chon", title: "Chọn chuỗi để thêm kịch bản này vào CUỐI chuỗi" });
  const them = h("button", { type: "button", class: "mini", "data-testid": "kb-them-vao-chuoi", title: "Thêm kịch bản này vào cuối chuỗi đã chọn — chuỗi chạy lần lượt từng kịch bản trên mỗi bot" }, "Thêm vào chuỗi");
  them.addEventListener("click", () => void busy(them, "Đang thêm…", async () => {
    if (!chon.value) { toast("Chọn một chuỗi trước", "warn"); return; }
    try { const c = await api<{ ten: string; buoc: unknown[] }>("POST", `/api/chuoi/${encodeURIComponent(chon.value)}/them`, { kichBanId: kbId }); toast(`Đã thêm vào chuỗi “${c.ten}” (bước ${c.buoc.length})`); await tai(); }
    catch (e) { toast(errMsg(e), "err"); }
  }));
  const moi = h("a", { class: "btn mini", href: `#/chuoi?them=${encodeURIComponent(kbId)}`, "data-testid": "kb-chuoi-moi", title: "Tạo chuỗi mới bắt đầu bằng kịch bản này (thêm kịch bản của mạng khác sau)" }, "＋ Chuỗi mới từ kịch bản này");
  chuoiBox.append(h("div", { class: "card ls-the", "data-testid": "kb-chuoi" },
    h("h3", {}, "Chuỗi kịch bản"),
    h("p", { class: "small muted" }, "Ghép nhiều kịch bản (khác mạng cũng được) để mỗi bot chạy lần lượt: xong kịch bản này mới sang kịch bản kế."),
    ds, h("div", { class: "row wrap" }, chon, them, moi)));
  function veChuoi(): void {
    clear(ds);
    if (!daTai) ds.append(h("li", { class: "muted small" }, "Đang tải…"));
    else if (loi) ds.append(h("li", { class: "err-box" }, `Không tải được chuỗi: ${loi}`));
    else if (!co.length) ds.append(h("li", { class: "empty small", "data-testid": "kb-chuoi-trong" }, "Kịch bản này chưa nằm trong chuỗi nào."));
    for (const c of daTai ? co : []) {
      ds.append(h("li", { class: "ls-dong", "data-testid": "kb-chuoi-dong" },
        h("a", { href: `#/chuoi/${encodeURIComponent(c.id)}`, title: "Mở chuỗi: thứ tự kịch bản, bot, chạy, tần suất" }, c.ten),
        h("span", { class: "small muted" }, `bước ${(c.viTri ?? []).join(", ")} / ${c.soBuoc}`)));
    }
    const giu = chon.value;
    clear(chon);
    chon.append(h("option", { value: "" }, khac.length || co.length ? "— chọn chuỗi —" : "Chưa có chuỗi nào"),
      ...[...khac, ...co].map((c) => h("option", { value: c.id }, `${c.ten} (${c.soBuoc} bước)`)));
    if ([...khac, ...co].some((c) => c.id === giu)) chon.value = giu;
  }
  veChuoi();
  void tai();
  return { ve: () => {}, huy: () => { song = false; lich.huy(); }, hienLich: (hien) => { khungLich.hidden = !hien; } };
}
